import { FlagContentParams } from './flag-content-interface';
export { FlagContentParams } from './flag-content-interface';
export { FlagReason } from './flag-content-interface';

export enum SendFeedbackType {
  Unknown = 'Unknown', // until user selects a type
  Question = 'Question',
  Like = 'Like',
  Dislike = 'Dislike',
  Suggestion = 'Suggestion',
  Issue = 'Issue',
};

export interface SendFeedbackParams {
  type?: 'sendFeedback';
  feedbackType?: SendFeedbackType;
  feedbackTitle: string;
  feedbackDescription: string;
  feedbackScreenshotImgDataUrl: string,
  sentryId: string;
  reporterName?: string;
  replyToEmail?: string;
  commonEventParams: any;
  managedClientUid?: string;
  managedClientDisplayName?: string;
}

export type FeedbackPayload = SendFeedbackParams | FlagContentParams;

export interface SendFeedbackResults {
  error?: string;
}